import { SubstituteCell as SubstituteCellComponent  } from './SubstituteCell.component'
import { connector } from './SubstituteCell.connector'

export const SubstituteCell = connector(SubstituteCellComponent)